var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'data-s-header',
    _vm.isDataArea ? 'data-s-header_2' : 'data-s-header_1' ]},[(!_vm.isDataArea)?[_c('h4',{staticClass:"data-s-title"},[_vm._v("天津市知识产权金融公共服务平台")])]:[_c('div',{staticClass:"data-s-title"},[_c('h4',[_vm._v(_vm._s(_vm.$store.getters.dataCondition.map.name))]),_c('h4',{staticStyle:{"margin-top":"5px"}},[_vm._v("知识产权质押融资大数据")])])]],2)}
var staticRenderFns = []

export { render, staticRenderFns }